function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * Created by pzf on 18/9/1.
 *
 */
export function addSelected(choosed, addItem, multiple) {
  if (multiple) {
    return [].concat(_toConsumableArray(choosed), [addItem]);
  } else {
    return [addItem];
  }
}
export function remove(choosed, removeItem, key) {
  var find = choosed.find(function (item) {
    return removeItem[key] === item[key];
  });

  if (find) {
    choosed.splice(choosed.indexOf(find), 1);
  }

  return _toConsumableArray(choosed);
}
export function isSelect(choosed, checkItem, key) {
  if (choosed.find(function (item) {
    return item[key] === checkItem[key];
  })) {
    return true;
  }

  return false;
}
export function batchAdd(choosed, category, key) {
  category.children.forEach(function (item) {
    if (!isSelect(choosed, item, key)) {
      choosed.push(item);
    }
  });
  return _toConsumableArray(choosed);
}
//# sourceMappingURL=util.js.map
